import { combineReducers } from 'redux';
import authenticationSlice from './slices/authenticationSlice';
import utilitySlice from './slices/utilitySlice';
import parserSlice from './slices/parserSlice';
import loginReducer from './slices/authenticationSlice';
import pagePermissionsSlice from './slices/pagePermissionsSlice';

export default combineReducers({
    authenticationSlice,
    utilitySlice,
    parserSlice,
    login: loginReducer,
    pagePermissions: pagePermissionsSlice
});
